import React from 'react';

/**
 * Shows first role name + red count (e.g. "Accountant + 35") for group Assigned Roles pickers.
 */
const RoleSelectionSummary = ({
  names = [],
  placeholder = '—',
  className = '',
  countClassName = 'assess-mod-groups-selection-count-badge',
}) => {
  if (!names.length) {
    return <span className={className}>{placeholder}</span>;
  }

  if (names.length === 1) {
    return <span className={className}>{names[0]}</span>;
  }

  const more = names.length - 1;

  return (
    <span className={`assess-mod-groups-selection-summary ${className}`.trim()}>
      <span className="assess-mod-groups-selection-summary__name truncate">{names[0]}</span>
      <span className={countClassName} title={`${more} more selected`}>
        +{more}
      </span>
    </span>
  );
};

export default RoleSelectionSummary;
